// Unified Reports Filter Form JavaScript

function handleTypeAndCustomerChangeUnifiedReports() {
  const typeSelect = document.querySelector('#report_type');
  const statusSelect = document.querySelector('#q_status_eq');
  const customerSelect = document.querySelector('#appointment_report_customer_id');
  
  if (statusSelect) {
    function updateStatusOptions() {
      // Primeiro, mostramos todas as opções
      statusSelect.querySelectorAll('option').forEach(option => {
        option.style.display = 'block';
      });

      const customerId = customerSelect ? customerSelect.value : null;
      const reportType = typeSelect ? typeSelect.value : null;

      // Se for administrador e tiver customer selecionado
      if (customerId) {
        // Esconde opções específicas de club_feedback
        statusSelect.querySelectorAll('option').forEach(option => {
          if (['expired', 'awaiting_feedback', 'feedback_submitted'].includes(option.value)) {
            option.style.display = 'none';
          }
        });
      }

      // Se tiver tipo de relatório selecionado
      if (reportType === 'appointment_report') {
        statusSelect.querySelectorAll('option').forEach(option => {
          if (option.value !== 'report_due' && option.value !== 'submitted' && option.value !== '') {
            option.style.display = 'none';
          }
        });
      } else if (reportType === 'club_feedback') {
        // Para club_feedback, mostramos todas as opções exceto report_due e submitted
        statusSelect.querySelectorAll('option').forEach(option => {
          if (option.value === 'report_due' || option.value === 'submitted') {
            option.style.display = 'none';
          } else {
            option.style.display = 'block';
          }
        });
      }

      // Se não tiver tipo selecionado, mostramos todas as opções
      if (!reportType) {
        statusSelect.querySelectorAll('option').forEach(option => {
          option.style.display = 'block';
        });
      }
    }

    // Adiciona listeners para mudanças
    if (typeSelect) {
      typeSelect.addEventListener('change', updateStatusOptions);
    }
    if (customerSelect) {
      customerSelect.addEventListener('change', updateStatusOptions);
    }

    // Executa uma vez no carregamento
    updateStatusOptions();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  handleTypeAndCustomerChangeUnifiedReports();
}); 

document.addEventListener("turbolinks:load", () => {
  handleTypeAndCustomerChangeUnifiedReports();
});